import DeleteIcon from "@mui/icons-material/Delete";
import { Typography } from "@mui/material";
import { ConfirmDialog, IconButton } from "bi-lib";
import { useState } from "react";

interface Props {
    onDelete: () => void;
}

export default function DeleteButton({ onDelete }: Props) {
    const [confirmOpen, setConfirmOpen] = useState(false);

    return (
        <>
            <ConfirmDialog onConfirm={onDelete} onClose={() => setConfirmOpen(false)} open={confirmOpen}>
                <Typography>Are you sure you want to delete this?</Typography>
            </ConfirmDialog>
            <IconButton tooltip={"Delete"} color={"error"} onClick={() => setConfirmOpen(true)}>
                <DeleteIcon />
            </IconButton>
        </>
    );
}
